export default __webpack_public_path__ + "static/media/d023f734b8ad22e9a275fd126180a254.svg";